import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.scss';
import AppProviders from './providers/AppProviders';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(
    <AppProviders>
        <App />
    </AppProviders>
);
